import { Link } from "react-router-dom";
import { SecretaryLayout } from "../Layout";
import { SummaryProcedureTable } from "../components/work_management/tables";
import { SummaryProcedureFilterForm } from "../components/work_management/forms";

export const SummaryProcedurePage = () => {
  // Datos de hooks ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="row">
            <div className="col-xl-9 col-md-6">
              <h5 className="mb-0">Resumen Jornadas</h5>

              <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/secretary/dashboard">gosafe</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Resumen Jornadas
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <div className="mt-4">
            <SummaryProcedureFilterForm />
          </div>

          <div className="mt-4">
            <SummaryProcedureTable />
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
